import {useEffect, useState} from "react";

export default (open) => {
  const [is_open, set_is_open] = useState(open);
  useEffect(()=>{set_is_open(open)},[open]);
  return [is_open, set_is_open]
};